import {
    Component,
    EventEmitter,
    Input,
    OnDestroy,
    OnInit,
    Output,
    ViewChild,
} from "@angular/core";
import { MatPaginator } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { merge, of, Subject, Subscription } from "rxjs";
import {
    catchError,
    filter,
    map,
    switchMap,
    takeUntil,
    tap,
} from "rxjs/operators";

import { fuseAnimations } from "@fuse/animations";
import { ContratistaService } from "app/main/apps/shared/services/rest/contratista.service";
import { config as CONFIG } from "app/app.config";

import { ContratistaDTO } from "app/main/apps/shared/models/contratista.model";

import { FuseProgressBarService } from "@fuse/components/progress-bar/progress-bar.service";
import { PageContratistaDTO } from "app/main/apps/shared/interfaces/page-contratista.interface";
@Component({
    selector: "app-tabla-contratistas",
    templateUrl: "./tabla-contratistas.component.html",
    styleUrls: ["./tabla-contratistas.component.scss"],
    animations: fuseAnimations,
})
export class TablaContratistasComponent implements OnInit, OnDestroy {
    @Input() contratistas: ContratistaDTO[];
    @Output() buscarMas: EventEmitter<void> = new EventEmitter();
    dataSource: MatTableDataSource<ContratistaDTO>;
    config: any;
    displayedColumns = [
        "p.nombres",
        "p.apellidos",
        "p.nrrut",
        "evaluacion",
        "activo",
    ];

    @ViewChild(MatPaginator, { static: true })
    paginator: MatPaginator;

    @ViewChild(MatSort, { static: true })
    sort: MatSort;

    // @ViewChild("filter", { static: true })
    // filter: ElementRef;
    //private subscripciones: Subscription;
    private _unsubscribeAll: Subject<any>;
    private subscripciones: Subscription;
    //resultsLength = 0;

    constructor(
        public _contratistaSrvc: ContratistaService,
        private _fuseProgressBarService: FuseProgressBarService
    ) {
        this.subscripciones = new Subscription();
        this._unsubscribeAll = new Subject();
        this.config = CONFIG;
    }

    ngOnInit(): void {
        this.dataSource = new MatTableDataSource(this.contratistas);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
        this.subscripciones.add(
            this.sort.sortChange.subscribe(() => (this.paginator.pageIndex = 0))
        );
        //this.buscadorListen();

        setTimeout(() => {
            this.tableChange();
        });
    }

    tableChange() {
        //this.subscripciones.add(
        merge(
            this.sort.sortChange.pipe(
                tap((data) => console.log("refreh sort", data))
            ),
            this.paginator.page.pipe(
                tap((data) => console.log("refreh paginator"))
            ),
            this._contratistaSrvc.contratistasRefresh$.pipe(
                tap((data) => console.log("refresh!", data)),
                filter(
                    (refresh) => refresh //filtro para contratistasRefresh$, merge se activa solo si el valor emitido es true, para evitar dobles llamadas
                )
            )
        )
            .pipe(
                // startWith({}),
                takeUntil(this._unsubscribeAll),

                switchMap((filtros) => {
                    //console.log(filtros);
                    this._fuseProgressBarService.show();
                    this._contratistaSrvc.setPaginaActual(
                        this.paginator.pageIndex
                    );
                    this._contratistaSrvc.setCantidaResultadosPorPagina(
                        this.paginator.pageSize
                    );

                    this._contratistaSrvc.setCampoOrden(this.sort.active);
                    this._contratistaSrvc.setOrden(this.sort.direction);

                    this.buscarMas.emit();
                    //return this.buscar();
                    return this._contratistaSrvc.contratistasChanged$;
                }),
                map((data: PageContratistaDTO) => {
                    // Flip flag to show that loading has finished.
                    //console.log("aspooooooo");
                    this._fuseProgressBarService.hide();

                    //this.resultsLength = data.totalElements;
                    this._contratistaSrvc.setTotalDeResultados(
                        data.totalElements
                    );

                    return data.content;
                }),
                catchError(() => {
                    this._fuseProgressBarService.hide();
                    // Catch if the GitHub API has reached its rate limit. Return empty data.

                    return of([]);
                })
            )
            .subscribe((data: ContratistaDTO[]) => {
                this.contratistas = data;
                this.dataSource = new MatTableDataSource(this.contratistas);
            });
        //);
    }

    // buscadorListen() {
    //     fromEvent(this.filter.nativeElement, "keyup")
    //         .pipe(
    //             takeUntil(this._unsubscribeAll),
    //             debounceTime(150),
    //             distinctUntilChanged()
    //         )
    //         .subscribe(() => {
    //             if (!this.dataSource) {
    //                 return;
    //             }
    //             console.log("entro");
    //             console.log(this.filter.nativeElement.value);
    //             this.dataSource.filter = this.filter.nativeElement.value;
    //         });
    // }

    ngOnDestroy() {
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
        this.subscripciones.unsubscribe();
    }
}
